import { State, did_any_change, did_change, get_state } from "../../redux/State";
import { Keys } from "../../redux/Datastore";
import { Attachment, AttachmentCollection } from "../../Attachment";
import { dispatch_action } from "../../redux/Dispatcher";
import { Action } from "../../redux/Actions";
import { Configuration } from "../../Configuration";



// assume the attachments array has been filtered for the expected floor
export function build_attachments_menu(attachments: Attachment[]): any {
    let r: any = {};
    r.images = 0;
    r.links = 0;


    attachments.forEach((attachment: Attachment) => {
        if (attachment.is_3D_link) {
            r.links++;
        }
        else {
            r.links++;
        }
    });
    return r;
}

class UI {
    public static get menu_attachments_container_div(): HTMLDivElement {
        return <HTMLDivElement>document.getElementById("menu_attachments_container");
    }
}

export function draw_attachments_menu() {
    if (!Configuration.attachments_feature_enabled) {
        return;
    }
    let state: State = get_state();
    if (did_change(Keys.KEY_STATE_FIRST_RUN)) {
        // setup html

        // The attachments menu has no header, only an attachments item.
        UI.menu_attachments_container_div.innerHTML = `
            <div class="collapse in" id="menu_attachments_content">
                <div class="card card-block">
                    <ul id="menu_attachments_content_list" class="list-group" style="padding: 2px"></ul>
                </div>
            </div>
`;

    }


    if (did_any_change([Keys.ALLOW_3D_LINK_CREATE, Keys.ALLOW_PHOTO_ATTACHMENT_CREATE])) {

        var allow_3d_link_create = state.get_boolean(Keys.ALLOW_3D_LINK_CREATE, false);
        var allow_photo_attachment_create = state.get_boolean(Keys.ALLOW_PHOTO_ATTACHMENT_CREATE, false);

        var li_attachments = `<li class='list-group-item' style='padding: 2px'>
<span class='glyphicon glyphicon-file'></span>
&nbsp;
<a href='#' id='attachments_menu_select' onclick='toggle_attachments_layer()'>Attachments</a>
<span class="badge" id='attachments_badge'></span>
</li>`;

        var li_photo = `<li class="list-group-item" style="padding: 2px;" id='attachments_menu_new_li'>
<a href="#" id="attachments_menu_new" onclick="dispatch(ACTION_UI_CREATEATTACHMENT_GET_COORD_START, 'image')">
    <span class="glyphicon glyphicon glyphicon-plus"></span> Add a Photo</a>
</li>`;

        var li_3D_link = `<li class="list-group-item" style="padding: 2px;" id='attachments_url_menu_new_li'>
<a href="#" id="attachments_url_menu_new" onclick="dispatch(ACTION_UI_CREATEATTACHMENT_GET_COORD_START, 'link')">
    <span class="glyphicon glyphicon glyphicon-share"></span> Add a Link</a>
</li>`;


        var contentUl = $("#menu_attachments_content_list");
        contentUl.html("");  // clear out the menu
        $(li_attachments).appendTo(contentUl);
        document.getElementById("attachments_menu_select").onclick = onclick_toggle_attachments_layer;
        if (allow_photo_attachment_create) {
            $(li_photo).appendTo(contentUl);
        }
        if (allow_3d_link_create) {
            $(li_3D_link).appendTo(contentUl);
        }
    }


    let build: boolean = did_any_change([
        Keys.KEY_MENU_ATTACHMENTS_CONTENT,
        Keys.ATTACHMENTS_DATA_HASH,
        Keys.KEY_MENU_ATTACHMENTS_SELECTED,
        Keys.ID_FLOOR,
        Keys.KEY_STATE_FIRST_RUN]);

    if (build) {


        let attachments: AttachmentCollection = get_state().attachments.get_for_floor(get_state().id_floor);//.get_json(Keys.KEY_MENU_ATTACHMENTS_CONTENT, {count:0});// getJSObject(new_imm_state, KEY_MENU_ATTACHMENTS_CONTENT, {})
        let state: State = get_state();
        $("#menu_attachments_content").show(400);
        $("#attachments_badge").html(`${attachments.count}`);

        let anchor = $("#attachments_menu_select");
        let li = anchor.parents("li");  // the parent of the anchor is a span, the parent of the span is an li. Hence we use jquery parents(), not parent()
        let selected_in_ui = li.hasClass("selected");
        if (state.menu_attachments_selected) {
            if (!li.hasClass("selected")) {
                li.addClass("selected");
            }
        }
        else {
            if (li.hasClass("selected")) {
                li.removeClass("selected");
            }
        }
    }
}


function onclick_toggle_attachments_layer() {
    let enabled = true;
    let anchor = $("#attachments_menu_select");
    let li = anchor.parents("li");         // the parent of the anchor is a span, the parent of the span is an li. Hence we use jquery parents(), not parent()
    let selected_in_ui = li.hasClass("selected");
    enabled = !selected_in_ui;

    dispatch_action(Action.toggle_attachments_layer(enabled));
}
